import { Skeleton } from '@chakra-ui/react'

const ProfileMenuSkeleton: React.FC = () => {
  return <Skeleton w='48px' h='48px' borderRadius='100%'></Skeleton>
}

export default ProfileMenuSkeleton
